import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/config";
import Logo from "../../assets/img/Logo.png";
import "../../styles/style.css";
import { useEffect } from "react";


const HidePassSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88" />
        </svg>
    )
}

const ViewPassSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
    )
}

//admin login
function SignIn() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const [remember, setRemember] = useState(false);
    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };


    useEffect(() => {
        const token = localStorage.getItem("adminToken");
        if (token) {
            navigate("/admin/dashboard");
        }
        const storedEmail = localStorage.getItem("admin_email") || "";
        const storedPassword = localStorage.getItem("admin_password") || "";
        const storedRemember = localStorage.getItem("admin_remember") === "1";

        setEmail(storedEmail);
        setPassword(storedPassword);
        setRemember(storedRemember);
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(
                `${API_URL}/login`,
                { email, password, remember },
                // { email: email.trim().toLowerCase(), password, remember },
                { withCredentials: true }
            );

            if (response.data.token) {
                localStorage.setItem("adminToken", response.data.token);

                if (remember) {
                    localStorage.setItem("admin_email", email);
                    localStorage.setItem("admin_password", password);
                    localStorage.setItem("admin_remember", "1");
                } else {
                    localStorage.removeItem("admin_email");
                    localStorage.removeItem("admin_password");
                    localStorage.removeItem("admin_remember");
                }

                navigate(response.data.redirect || "/admin/dashboard");
            } else {
                setError("Invalid credentials.");
            }
        } catch (err) {
            console.error(
                "Login error:",
                err.response ? err.response.data : err.message
            );
            setError(
                err.response?.data?.error ||
                "Login failed. Please check your email and password."
            );
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError("");
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [error]);

    if (loading) return <div></div>;
    // if (error) return <div>{error}</div>;
    return (
        <div className="signin-screen">
            <div className="logo">
                <img src={Logo} alt="Logo" />
            </div>
            <form className="signin-width" onSubmit={handleLogin}>
                <h2 className="signin-head">Admin Login</h2>

                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}

                <div className="input-group">
                    <input
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>

                <div className="input-group password-group">
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder='Password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    <span className={`viewpass-icon ${showPassword ? "active" : ""}`} onClick={togglePasswordVisibility} >
                        {showPassword ? <ViewPassSvg /> : <HidePassSvg />}
                    </span>
                </div>

                <div className="check-bx">
                    <label htmlFor="Remember" className="remember-label">
                        <input
                            type="checkbox"
                            id="Remember"
                            checked={remember}
                            onChange={(e) => setRemember(e.target.checked)}
                        />
                        <span>Remember Me</span>
                    </label>
                </div>

                <button className='sign-in-button' type='submit'>Sign In</button>

            </form>
        </div>
    );
}

export default SignIn;
